import { render, staticRenderFns } from "./GameInfoBadge.vue?vue&type=template&id=a0edbe0c&scoped=true"
import script from "./GameInfoBadge.vue?vue&type=script&lang=js"
export * from "./GameInfoBadge.vue?vue&type=script&lang=js"
import style0 from "./GameInfoBadge.vue?vue&type=style&index=0&id=a0edbe0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0edbe0c",
  null
  
)

export default component.exports